import { useCallback, useState } from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import {
  Card,
  Dialog,
  DialogTitle,
  Divider,
  Button as MuiButton,
} from "@material-ui/core";
import { ChangeSelectedEventsCoDriverForm } from "./ChangeSelectedEventsCoDriverForm";
import { GroupOutlined } from "@material-ui/icons";

interface Props {
  selectedRows: number[];
  currentCoDrivers?: Array<number | null | undefined>;
  shouldRenderReactAdminButton?: boolean;
}

export const ChangeEventsCoDriver = ({
  selectedRows,
  currentCoDrivers,
  shouldRenderReactAdminButton = true,
}: Props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const handleFailed = useCallback(() => setDialogOpen(false), []);
  const handleSuccess = useCallback(() => {
    setDialogOpen(false);
    notify(
      "resources.hos-driver-log-view.messages.changeEventsCoDriverSuccess",
      {
        type: "success",
      }
    );
    refresh();
  }, [refresh, notify]);

  return (
    <>
      {shouldRenderReactAdminButton ? (
        <Button
          className="master-action"
          label="Change co-driver..."
          onClick={() => setDialogOpen(true)}
        >
          <GroupOutlined />
        </Button>
      ) : (
        <MuiButton
          color="primary"
          variant="text"
          onClick={() => setDialogOpen(true)}
          startIcon={<GroupOutlined />}
        >
          Change co-driver
        </MuiButton>
      )}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Change co-driver for {selectedRows.length} event(s)
        </DialogTitle>
        <Divider />
        <Card>
          <ChangeSelectedEventsCoDriverForm
            selectedRows={selectedRows}
            currentCoDrivers={currentCoDrivers}
            onSuccess={handleSuccess}
            onFailed={handleFailed}
          />
        </Card>
      </Dialog>
    </>
  );
};
